import {
  getOrderBadgeStatusClass,
  SARIconThemeColor,
  setMobileBackColor,
  setMobileButttonBackColor,
  setMobileCardBorderColor,
  setMobileCardColor,
  setMobileTextColor,
} from "../utility";
import { Badge, Container, Navbar } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import coverSample from "../images/No_Image_Available.jpg";
import no_image from "../images/No_Image_Available.jpg";

import axios from "axios";
import { useQuery } from "react-query";
import "../css/mobileScreens.css";
import Loading from "../common/loading";
import { Button } from "@mui/material";
import {
  ArrowBackOutlined,
  CreateOutlined,
  MenuOutlined,
  PaymentOutlined,
  ReceiptOutlined,
  StorefrontOutlined,
} from "@mui/icons-material";
import { t } from "i18next";
import ErrorDialog from "../common/errorDialog";
import BottomNavBar from "../components/BottomNavBar";

const OrderDetails = () => {
  const queryString = window.location.search;
  const urlParam = new URLSearchParams(queryString);


  const { id, qrName, qrCode } = useParams();

  const navigate = useNavigate();

  const lang = localStorage.getItem("lang");

  const {
    data: publicData,
    isLoading: publicIsLoading,
    isError: publicIsError,
  } = useQuery("public-order", async () => {
    const timeZone = localStorage.getItem("timezone") ? localStorage.getItem("timezone") : "";
    const MobileToken = localStorage.getItem("mobileLoginToken");
    return await axios.get(
      `${process.env.REACT_APP_API
      }/menus/${qrCode}/public-orders?token=${localStorage.getItem(
        "gustToken"
      )}`,
      { headers: { localization: lang, Authorization: `Bearer ${MobileToken}`, timeZone: timeZone.replace(/["]+/g, '') } }
    );
  });

  const {
    data: detailsData,
    isLoading: detailsIsLoading,
    isError: detailsIsError,
  } = useQuery("public-details-order", async () => {
    try {
      const promise = await axios.get(
        `${process.env.REACT_APP_API}/menus/${qrCode}/public-details`,
        { headers: { localization: localStorage.getItem("lang") } }
      );
      if (promise.status === 200) {
        if (!localStorage.getItem("showOption")) {
          localStorage.setItem(
            "showOption",
            promise.data.data.mobile_settings?.showOption
          );
        }
        if (promise.data.data.mobile_settings?.theme === "costomize") {
          localStorage.setItem(
            "theme",
            promise.data.data.mobile_settings?.theme
          );
          localStorage.setItem(
            "textColor",
            promise.data?.data.mobile_settings.colorProps.text
          );
          localStorage.setItem(
            "backColor",
            promise.data?.data.mobile_settings.colorProps.back
          );
          localStorage.setItem(
            "cardColor",
            promise.data?.data.mobile_settings.colorProps.card
          );
          localStorage.setItem(
            "highlights",
            promise.data?.data.mobile_settings.colorProps.highlights
          );
        } else {
          if (
            localStorage.getItem("theme") !== "dark" &&
            localStorage.getItem("theme") !== "light"
          ) {
            localStorage.setItem(
              "theme",
              promise.data.data.mobile_settings?.theme
            );
          }
        }
      }
      return promise;
    } catch (error) { }
  });

  const handleBack = () => {
    navigate(
      `/${qrName}/${qrCode}/orders?section=${urlParam.get(
        "section"
      )}&t=${urlParam.get("t")}`
    );
  };

  const onImageError = (e) => {
    e.target.src = coverSample;
  };

  if (publicIsLoading || detailsIsLoading) {
    return <Loading backColor={setMobileBackColor()} />;
  }

  if (publicIsError || detailsIsError) {
    return <ErrorDialog />;
  }

  const index = publicData?.data.data.orders.findIndex(order => Number(order.order_id) === Number(id));


  const order = publicData?.data.data.orders[index];

  return (
    <div
      className={`min-vh-100`}
      style={{ backgroundColor: setMobileBackColor() }}
    >
      <Container fluid>
        <div className="row">
          <div className="col-lg-8 d-none d-lg-block">
            <div className="mt-5 text-center d-flex-justify-content-center align-items-center">
              <div style={{ marginTop: "20%" }}>
                <img
                  alt=""
                  src={detailsData.data.data?.logo || no_image}
                  className="me-4"
                  style={{ width: "250px", height: "250px" }}
                  onError={onImageError}
                />
                <h1
                  className="mt-4 head-font"
                  style={{ color: setMobileTextColor() }}
                >
                  {detailsData.data.data?.venu_name}
                </h1>
              </div>
            </div>
          </div>

          <div className="col-lg-4 ms-auto p-0">
            <div className="mobile-side-screen">
              <Navbar
                className={`d-flex justify-content-between align-items-center position-fixed top-0 z-2 mobile-nav`}
                style={{
                  width: "100%",
                  margin: "auto",
                  backgroundColor: setMobileCardColor(),
                }}
              >
                <Button
                  onClick={handleBack}
                  style={{ color: setMobileTextColor() }}
                >
                  <ArrowBackOutlined sx={{ color: setMobileTextColor() }} />
                </Button>

                <Navbar.Brand className="text-center m-0">
                  <p
                    className="mb-1 text-center sub-font"
                    style={{ color: setMobileTextColor() }}
                  >
                    {detailsData.data.data?.table}
                  </p>
                </Navbar.Brand>

              </Navbar>

              <div className="mx-2 alignByLang" style={{ marginTop: "64px" }}>
                <div
                  className="m-top-12 p-24 rounded-4"
                  style={{
                    border: `1px solid ${setMobileCardBorderColor()} `,
                    backgroundColor: setMobileBackColor(),
                  }}
                >
                  <h2
                    style={{ color: setMobileTextColor() }}
                    className="sub-font font-size-22 mb-4"
                  >
                    <StorefrontOutlined
                      style={{ color: setMobileTextColor() }}
                      fontSize="large"
                    />
                    <span
                      className="mx-2"
                      style={{ color: setMobileTextColor() }}
                    >{`${t("Delivry from")} (${detailsData?.data.data.venu_name
                      })`}</span>
                  </h2>
                  <div className="d-flex justify-content-between">
                    <span
                      style={{ color: setMobileTextColor() }}
                      className="sub-font"
                    >
                      {t("Order Location :")}
                    </span>
                    <span
                      style={{ color: setMobileTextColor() }}
                      className="head-font"
                    >
                      {order?.location ? order?.location : ""}
                    </span>
                  </div>
                </div>
                <div
                  className="m-top-12 p-24 rounded-4"
                  style={{
                    border: `1px solid ${setMobileCardBorderColor()} `,
                    backgroundColor: setMobileBackColor(),
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                    <h2
                      style={{ color: setMobileTextColor() }}
                      className="sub-font font-size-22 mb-4"
                    >
                      <ReceiptOutlined
                        style={{ color: setMobileTextColor() }}
                        fontSize="large"
                      />
                      <span
                        className="mx-2"
                        style={{ color: setMobileTextColor() }}
                      >
                        {t("Order details")}
                      </span>
                    </h2>

                    <p className="mb-2 alignByLang">
                      <Badge
                        className={` ${getOrderBadgeStatusClass(
                          order.status
                        )} p-2 font-size-12 sub-font m-1`}
                      >{t(order.status) || ""}
                      </Badge>
                    </p>
                  </div>

                  <div className="d-flex justify-content-between">
                    <span
                      style={{ color: setMobileTextColor() }}
                      className="sub-font"
                    >
                      {t("Order number :")}
                    </span>
                    <span
                      style={{ color: setMobileTextColor() }}
                      className="head-font"
                    >
                      #{order.order_id}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between mt-2">
                    <span
                      style={{ color: setMobileTextColor() }}
                      className="sub-font"
                    >
                      {t("Order Time :")}
                    </span>
                    <span
                      style={{ color: setMobileTextColor() }}
                      className="head-font"
                    >
                      {order.time}
                    </span>
                  </div>
                  <div
                    style={{
                      borderBottom: `1px solid ${setMobileCardColor()}`,
                    }}
                    className="d-flex justify-content-between mt-2 pb-2"
                  >
                    <span
                      style={{ color: setMobileTextColor() }}
                      className="sub-font"
                    >
                      {t("Customer Name :")}
                    </span>
                    <span
                      style={{ color: setMobileTextColor() }}
                      className="head-font"
                    >
                      {order.customer}
                    </span>
                  </div>
                  {order?.items.map((item) => (
                    <div
                      className="pb-2"
                      style={{
                        borderBottom: `1px solid ${setMobileCardColor()}`,
                      }}
                    >
                      <div
                        key={item.id}
                        className="d-flex justify-content-between mt-2 pb-2"
                      >
                        <span
                          style={{ color: setMobileTextColor() }}
                          className="sub-font"
                        >
                          {item.name}
                        </span>
                        <span
                          style={{ color: setMobileTextColor() }}
                          className="head-font"
                        >
                          {item.qty}
                        </span>
                        <span
                          style={{ color: setMobileTextColor() }}
                          className="head-font"
                        >
                          {item.price} {detailsData?.data.data.currency_symbol ? detailsData?.data.data.currency_symbol === "SAR" ? <img width={20} height={20} src={SARIconThemeColor()} className="mr-1" /> : detailsData?.data.data.currency_symbol : ""}

                        </span>
                      </div>
                      {item.notes && (
                        <div>
                          <span
                            className="head-font"
                            style={{ color: setMobileButttonBackColor() }}
                          >
                            {t("Comments")}
                          </span>
                          <p
                            className="sub-font"
                            style={{ color: setMobileTextColor() }}
                          >
                            {item.notes.split("//").map((element, index) => (
                              <p
                                key={index}
                                className="font-size-16 cursor mb-1"
                                style={{
                                  color: order.price_changed
                                    ? "#F04438"
                                    : setMobileTextColor(),
                                }}
                              >
                                {element}
                              </p>
                            ))}
                          </p>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
                <div
                  className="m-top-12 p-24 rounded-4"
                  style={{
                    border: `1px solid ${setMobileCardBorderColor()} `,
                    backgroundColor: setMobileBackColor(),
                  }}
                >
                  <h2
                    style={{ color: setMobileTextColor() }}
                    className="sub-font font-size-22"
                  >
                    <CreateOutlined style={{ color: setMobileTextColor() }} fontSize="large" />
                    <span
                      className="mx-2"
                      style={{ color: setMobileTextColor() }}
                    >
                      {t("Customer Notes")}
                    </span>
                  </h2>
                  <p>{order.note}</p>
                </div>
                <div
                  className="m-top-12 p-24 rounded-4 mb-4"
                  style={{
                    border: `1px solid ${setMobileCardBorderColor()} `,
                    backgroundColor: setMobileBackColor(),
                  }}
                >
                  <h2 className="sub-font font-size-22 mb-4">
                    {" "}
                    <PaymentOutlined
                      style={{ color: setMobileTextColor() }}
                      fontSize="large"
                    />{" "}

                    <span
                      className="mx-2"
                      style={{ color: setMobileTextColor() }}
                    >
                      {t("Pay Details")}
                    </span>

                  </h2>
                  <p className="font-size-18 d-flex justify-content-between sub-font primary-color">
                    <span
                      style={{ color: setMobileTextColor() }}
                      className="sub-font"
                    >
                      {t("Payment method")}
                    </span>

                    <span
                      style={{ color: setMobileTextColor() }}
                      className="sub-font"
                    >
                      {order.payment_method}
                    </span>
                  </p>
                  <p className="font-size-18 d-flex justify-content-between sub-font primary-color">
                    <span
                      style={{ color: setMobileTextColor() }}
                      className="sub-font"
                    >
                      {t("Total")}
                    </span>{" "}

                    <span
                      style={{ color: setMobileTextColor() }}
                      className="sub-font"
                    >
                      {order.total} {detailsData?.data.data.currency_symbol ? detailsData?.data.data.currency_symbol === "SAR" ? <img width={20} height={20} src={SARIconThemeColor()} className="mr-1" /> : detailsData?.data.data.currency_symbol : ""}
                    </span>

                  </p>
                  <p
                    className="font-size-18 d-flex justify-content-between sub-font primary-color pb-2"
                    style={{
                      borderBottom: `1px solid ${setMobileCardColor()}`,
                    }}
                  >

                    <span
                      style={{ color: setMobileTextColor() }}
                      className="sub-font"
                    >
                      {t("Services")}
                    </span>{" "}

                    <span
                      style={{ color: setMobileTextColor() }}
                      className="sub-font"
                    >
                      {order.service} {detailsData?.data.data.currency_symbol ? detailsData?.data.data.currency_symbol === "SAR" ? <img width={20} height={20} src={SARIconThemeColor()} className="mr-1" /> : detailsData?.data.data.currency_symbol : ""}
                    </span>

                  </p>
                  <p className="font-size-18 d-flex justify-content-between blue-color head-font primary-color">
                    <span style={{ color: setMobileTextColor() }} className="head-font">{t("In total")}</span>{" "}
                    <span style={{ color: setMobileTextColor() }} className="head-font">
                      {order.total + order.service}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
      <BottomNavBar qr={qrCode} qrName={qrName} />

    </div>
  );
};

export default OrderDetails;
